/* 

----- Component Loader ----- 
Component loader is responsible for loading in the various express dependancies, the functionality includes exporting the various JS chunks / bundles at the compilation stage ( when using build tools ) to dynamically loading in the various modules when their initialise selector is referenced in the DOM.
*/

var instances = {};

function setInstance(id) {
    return instances[id] = {}
}

function getInstance(id) {
    return instances[id];
}

function setStatus(id, value) {
    return instances[id]['status'] = value;
}

function getStatus(id) {
    return instances[id]['status'];
}
// This container the actual components that have been loaded.
function setInstanceComponents(id, value) {
    if (!instances[id].hasOwnProperty('components')) {
        instances[id]['components'] = [];
    }
    return instances[id]['components'].push(value);
}

function getInstanceComponents(id) {
    return instances[id]['components'];
}

// Just a list of component names that have been loaded.
function setInstanceComponentsName(id, value) {
    if (!instances[id].hasOwnProperty('components-names')) {
        instances[id]['components-names'] = [];
    }
    return instances[id]['components-names'].push(value);
}

function getInstanceComponentsName(id) {
    return instances[id]['components-names'];
}

function setContainer(id, value) {
    return instances[id]['containers'] = value;
} 

function getContainer(id) {
    return instances[id]['containers'];
}

// All the various Javascript components that build up express.
// TODO: will mostly likely need to add an addtional property for when a module depends on another.
var components = [
    {
        "name": "axis-crypto",
        "utility": true
    },
    {
        "name": "axis-local-storage-manager",
        "utility": true
    },
    {
        "name": "axis-indexed-db",
        "utility": true
    },
    {
        "name": "axis-schema-data" // Making this the first module to get loaded in to try and react to crawlers as quickly as possible.
    },
    {
        "name": "axis-payment-methods"
    },
    {
        "name": "axis-value-total"
    },
    {
        "name": "axis-responsive-tabs"
    },
    {
        "name": "axis-additional-images"
    },
    {
        "name": "axis-lightbox"
    },
    {
        "name": "axis-youtube-player"
    },
    {
        "name": "axis-image-360"
    },
    {
        "name": "axis-magnifier"
    },
    {
        "name": "axis-reviews"
    },
    {
        "name": "axis-countdown"
    },
    {
        "name": "axis-multimedia-element"
    },
    {
        "name": "axis-carousel"
    },
    {
        "name": "axis-admin"
    },
    {
        "name": "axis-captcha"
    },
    {
        "name": "axis-interactive-maps"
    },
    {
        "name": "axis-predictive-search"
    },
    {
        "name": "axis-animations"
    },
    {
        "name": "axis-barcode-scanner"
    },
    {
        "name": "axis-tree-menu"
    },
    {
        "name": "axis-stockline"
    },
    {
        "name": "axis-motion-ui"
    },
    {
        "name": "axis-element-print"
    },
    {
        "name": "axis-code-block"
    },
    {
        "name": "axis-context-menu"
    },
    {
        "name": "axis-rich-text-editor"
    },
    {
        "name": "axis-charts"
    },
    {
        "name": "axis-copy-to-clipboard"
    },
    {
        "name": "axis-third-party-search"
    },
    {
        "name": "axis-paint-selector"
    },
    {
        "name": "axis-video-player"
    },
    {
        "name": "axis-anchors"
    },
    {
        "name": "axis-download-file"
    }
];

function initialise(container) {
    // Create instance Id.
    let id = generateId();
    // Create instance.
    setInstance(id);
    // Update instance.
    setContainer(id, container);
    // Get / Load the component.
    return getComponents(id);
}

function getComponents(id) {
    // Get the container.
    let container = getContainer(id);
    // Start the loading process.
    let loadComponents = new Promise((resolve, reject) => {
        // Loop through components.
        components.forEach(entry => {
            //console.warn("A module has been detected", entry['name']);
            // // Get the component name.
            let name = entry['name'];
            if (!name) {
                console.error("Component Loader: Please specific the component name");
                return false;
            }
            // Check whether this component has been previously loaded.
            let isActive = isComponentLoaded(name);
            // Find the selectors for this component.
            let selectors = (expressSelectors().hasOwnProperty(name) ? expressSelectors()[name] : false);
            // Check if this module is just a utility function.
            let isUtility = (entry.hasOwnProperty('utility') ? entry['utility'] : false);
            // If exists then proceed to initialisation.
            if (selectors) {
                // Find the initialising selector.
                let init = (selectors.hasOwnProperty('initialise') ? selectors['initialise'] : false);
                // Is this component required?
                let required = ((container ? container.find('[' + init + ']').length : $('[' + init + ']').length > 0));
                // If initialise selector exists.
                if (required && !isActive) {
                    // Update status.
                    setStatus(id, "pending");
                    let component = getComponent(name).then((component) => {
                        // Signal that this compnent is ready.
                        componentReady(name, container);
                        // Return the component.
                        return {
                            "status": "success",
                            "name": name,
                            "component": component
                        };
                        // console.log(instance);
                    }).catch((error) => {
                        console.error(error);
                        return {
                            "status": "failed",
                            "name": name,
                            "error": error
                        }
                    });
                    // Add component to instance.
                    setInstanceComponents(id, component);
                    // Add component name
                    setInstanceComponentsName(id, name);
                } else if(required && isActive) {
                    // If required and is already loaded then return the loaded component.
                    let component = new Promise((resolve) => {
                        if (AXISDebug.level() >= 3) {
                            AXISDebug.output(1, "Component Loader: " + name + " has previously been loaded.");
                        }
                        // Signal that the component is ready to use.
                        componentReady(name, container);
                        resolve({
                            "status": "success", 
                            "name": name,
                            "component": window[camelise(name)]
                        });
                    });
                    // Add component to instance.
                    setInstanceComponents(id, component);
                    // Add component name
                    setInstanceComponentsName(id, name);
                }
            } else if (isUtility) { // Specifically for utility / helper functions that do not directly interact with the DOM.
                // Update status.
                setStatus(id, "pending");
                let component = getComponent(name).then((component) => {
                    // Signal that this compnent is ready.
                    componentReady(name, undefined, true);
                    // Return the component.
                    return {
                        "status": "success",
                        "name": name,
                        "component": component
                    };
                    // console.log(instance);
                }).catch((error) => {
                    console.error(error);
                    return {
                        "status": "failed",
                        "name": name,
                        "error": error
                    }
                });
            } else {
                // If no selectors found then exit as we will not be able to initialise.
                console.error("Component loader: No selectors found for this component " + name + ", please look at expressSelectors()", expressSelectors());
                return false;
            }
        });
        // If components have been loaded.
        if (getInstanceComponents(id)) {
            // Once all components have been loaded then return the list.
            Promise.all(getInstanceComponents(id)).then((components) => {
                setStatus(id, "complete");
                // Return the names of components loaded.
                resolve({
                    "status": "complete",
                    "message": "Component Loader: Here are the components that have been succesfully loaded:",
                    "components": components
                });    
            
            }).catch((error) => console.error(error));
        } else {
            // If no components are required then simple resolve the promise.
            resolve({
                "status": "complete",
                "message": "Component Loader: No additional components required"
            });
        }
        
    });
    return loadComponents;
}

// Actually get the component.
function getComponent(name) {
    return new Promise((resolve, reject) => {
        if (!name) {
            reject("Component Loader: You must provide a component name that you want to load");
        }
        // Do the import.
        // Setting the magic comment chunk name to request to match the src file name https://stackoverflow.com/questions/52339114/how-to-generate-dynamic-import-chunk-name-in-webpack
        import( /* webpackChunkName: "[request]" */ `/${name}`).then((module) => {
            let component = module['component'];
            if (!component) {
                reject("Component Loader: Could not find component declaration in module " + name + ".");
            }
            // Put component in global namespace.
            window[camelise(name)] = component;
            // Return component.
            resolve(component);
        }).catch((error) => reject(error));
    });
}

// Check if component has already been loaded.
function isComponentLoaded(name) {
    if (!name) {
        console.error("Component Loader: You must provide a component name to check if it is loaded");
        return false;
    }
    return (typeof window[camelise(name)] !== 'undefined' ? window[camelise(name)] : false);
}

// Check other instance if this module has been requested.
function isComponentLoading(name) {
    let isLoading = false;
    // Loop through instances.
    for (let instance in instances) {
        if (instances[instance]['components-names'].indexOf("axis-image-360") > 0) {
            isLoading = true;
            break;
        }
    }
    return isLoading;
}

// Fire event when the component is ready for the initialisation process.
function componentReady(name, container, isUtility = false) {
    // Create an initialisation event.
    let event = new CustomEvent("component-ready", { 
        "detail": {
            "selector": name,
            "component": camelise(name),
            "containers": (container ? container : false),
            "is-utility": isUtility
        }
    });
    // Trigger event.
    window.dispatchEvent(event);
    // Fire an event specifically for this module, just incase this is a dependancy for another module.
    window.dispatchEvent(new CustomEvent("component-" + name + "-ready"));
}

var component = $.component = {
    initialise: (container) => {
        return initialise(container);
    },
    getComponents: (id) => {
        return getComponents(id);
    },
    getComponent: (name) => {
        return getComponent(name);
    },
    isComponentLoaded: (name) => {
        return isComponentLoaded(name);
    },
    isComponentLoading: (name) => {
        return isComponentLoading(name);
    }
}

export { component };